module.exports = __webpack_public_path__ + "img/物联网智慧平安小区运营管理平台［简称：运营管理平台］V1.0.3a267abb.png";